import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl text-background-50">丝瓜视频</span>
              </div>
              <p className="text-foreground-400 text-sm leading-relaxed">
                聚合51视频、91视频等平台最新影视资源，热门电视剧、电影、综艺、动漫免费在线追剧，高清不缓冲，新剧上线第一时间更新。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">影视分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer"
                    >
                      <i className={`${cat.icon} mr-1.5 text-xs`}></i>
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">快捷链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/"
                    className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer"
                  >
                    服务条款
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer"
                  >
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">关注我们</h4>
              <div className="flex gap-3 mb-4">
                <a
                  href="#"
                  className="w-10 h-10 rounded-lg bg-foreground-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200 cursor-pointer"
                  aria-label="微博"
                  rel="nofollow"
                >
                  <i className="ri-weibo-line text-lg text-background-50"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 rounded-lg bg-foreground-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200 cursor-pointer"
                  aria-label="微信"
                  rel="nofollow"
                >
                  <i className="ri-wechat-line text-lg text-background-50"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 rounded-lg bg-foreground-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200 cursor-pointer"
                  aria-label="B站"
                  rel="nofollow"
                >
                  <i className="ri-bilibili-line text-lg text-background-50"></i>
                </a>
              </div>
              <p className="text-foreground-400 text-sm">
                客服邮箱：service@sigua.video
              </p>
            </div>
          </div>

          <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-xs">
              &copy; {currentYear} 丝瓜视频 sigua.video — 本站内容仅供展示，不提供实际播放服务
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-500 hover:text-foreground-300 text-xs transition-colors cursor-pointer" rel="nofollow">
                服务条款
              </a>
              <a href="#" className="text-foreground-500 hover:text-foreground-300 text-xs transition-colors cursor-pointer" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-foreground-500 hover:text-foreground-300 text-xs transition-colors cursor-pointer" rel="nofollow">
                DMCA
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}